
import React, { Component } from 'react';

import { messages } from '../../common/messages';
import config from '../../views/config/App_data';
export class ReportCard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      reportLoading: false,
      successAlert: false,
      comment: '',
    };
  }

  report = async () => {
    const { comment } = this.state;
    const { itemId, keyId='', section = '', mockData ,apiServiceProvider ,level='' } = this.props;
    this.setState({ reportLoading: true });
    const data = {
      [keyId]: itemId,
      comment,
      mockData,
      level
    };
    let apiService = apiServiceProvider['reportQuestion'];

    switch (section.toLowerCase()) {
      case 'cbt':
        apiService = apiServiceProvider['reportCBTQuestion'];
        break;
      case 'video':
        apiService = apiServiceProvider['mutateReportVideo'];
        break;

      default:
        apiService = apiServiceProvider['reportQuestion'];
        break;
    }

    const response = await apiService(data);
    if (response.success) {
      this.setState({ successAlert: true, comment: '' });
    }
    this.setState({ reportLoading: false });
  };

  render() {
    const { reportLoading, comment } = this.state;
    const { hideReportSection } = this.props;
    return (
      <div className='row'>
        <div className='col-md-12'>
          <div className='card'>
            <div className='card-header'>{messages.REPORT}</div>
            {!this.state.successAlert ? (
              <div className='card-block'>
                <div className='row'>
                  <div className='col-xs-12 col-sm-12 col-md-12'>
                    <label className='form-control-label' htmlFor='textarea-input'>
                      <strong>{messages.COMMENT}</strong>
                    </label>
                  </div>
                  <div className='col-xs-12 col-sm-12 col-md-12 margin_bottom_10'>
                    <textarea
                      onChange={event => this.setState({ [event.target.name]: event.target.value })}
                      id='comment'
                      name='comment'
                      rows='6'
                      value={comment}
                      className='form-control'
                      placeholder='Content..'
                    />
                  </div>
                </div>
                <div className='row'>
                  <div className='col-xs-12 col-sm-12 col-md-12'>
                    <button
                      type='button'
                      className='btn btn-primary active pointer_class report-btn'
                      disabled={reportLoading}
                      onClick={this.report}
                    >
                      {reportLoading ? messages.PLEASE_WAIT : messages.REPORT}
                    </button>
                    <button
                      type='button'
                      className='btn btn-danger active pointer_class margin_left_10'
                      onClick={hideReportSection}
                    >
                      {messages.CANCEL}
                    </button>
                  </div>
                </div>
              </div>
            ) : (
              <div className='card-block'>
                <div className='row'>
                  <div className='col-sm-12 report-Success-card'>
                    <img src={`${config.frontend_url}/img/success-ic.svg`} alt='' />
                    <label className='form-control-label' htmlFor='textarea-input'>
                      <strong> {messages.REPORT_SEND_SUCCESS_MESSAGE}</strong>
                    </label>
                    <button
                      type='button'
                      className='btn btn-primary active pointer_class  min-vw-120'
                      onClick={hideReportSection}
                    >
                      {' '}
                      {messages.CLOSE}
                    </button>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}

export default ReportCard;



// WEBPACK FOOTER //
// ./src/Components-2025/QuestionBank/ReportCard.jsx